
export function safeParseHeadFromStorage(name) {
    const key = `head_${name}`;

    try {
        const raw = localStorage.getItem(key);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}


export function mergeHeadWithStorage(name, defaultHead) {
    const saved = safeParseHeadFromStorage(name);
    const savedById = new Map(saved.map((c) => [c.id, c]));

    const base = Array.isArray(defaultHead) ? defaultHead : [];

    const merged = base.map((defCol) => {
        const savedCol = savedById.get(defCol.id);

        if (savedCol && typeof savedCol.displayGrid === 'boolean') {
            return { ...defCol, displayGrid: savedCol.displayGrid };
        }
        return { ...defCol };
    });

    // update local storage
    try {
        localStorage.setItem(`head_${name}`, JSON.stringify(merged));
    } catch (e) {
        // ignore
    }

    return merged;
}
